import { FieldValues, FormState } from 'react-hook-form';
import { GlobalEquipment, EquipmentTypeKeepNulls } from '../types';

export type IAnyDirty = FormState<EquipmentTypeKeepNulls>['dirtyFields'];
type EquipmentEntries = readonly [
  string,
  EquipmentTypeKeepNulls[keyof EquipmentTypeKeepNulls],
];
export type IFilteredEntries = EquipmentEntries | readonly [string, undefined];

export function catchAllSingle<T extends FieldValues, K extends keyof T>(
  keyt: K,
  valuesT: T,
  anyDirty: FormState<T>['dirtyFields'],
): [K, T[K]] | [K, undefined] {
  type IDirtyKey = keyof typeof anyDirty;
  // Not there
  if (anyDirty[keyt as IDirtyKey] === undefined) return [keyt, undefined];
  // Anything forcefully unit
  const bool = !!anyDirty[keyt as IDirtyKey];
  if (typeof anyDirty[keyt as IDirtyKey] === 'boolean') {
    if (bool === true) return [keyt, valuesT[keyt]];
    return [keyt, undefined];
  }
  return [keyt, valuesT[keyt]] as [never, never];
}
export function checkCustomFields(
  keyt: 'customFields',
  valuesT:
    | Pick<EquipmentTypeKeepNulls, 'customFields'>
    | Pick<GlobalEquipment, 'customFields'>,
  anyDirty: Pick<IAnyDirty, 'customFields'>,
): IFilteredEntries {
  // customfields
  const dirtycustomfields = anyDirty[keyt];
  const valueT = valuesT[keyt];
  if (!dirtycustomfields) return [keyt, undefined] as const;

  const customFieldsToSend = Object.entries(valueT).filter(
    (
      value2,
    ): value2 is [string, EquipmentTypeKeepNulls['customFields'][string]] =>
      Boolean(dirtycustomfields[value2[0]]?.content),
  );
  if (customFieldsToSend.length === 0) return [keyt, undefined] as const;
  return [keyt, Object.fromEntries(customFieldsToSend)] as const;
}
